'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminPublicationsController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

  var API = '/api/publications';

  $scope.publications   = [];
  $scope.categories     = [];
  $scope.isLoading      = true;
  $scope.showModal      = false;
  $scope.saving         = false;
  $scope.currentPage    = 1;
  $scope.itemsPerPage   = 10;
  $scope.totalItems     = 0;
  $scope.totalPages     = 0;
  $scope.searchQuery    = '';
  $scope.filterCategory = '';
  $scope.editingPub     = {};
  $scope.successMsg     = '';
  $scope.errorMsg       = '';

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  $scope.loadPublications = function() {
    $scope.isLoading = true;
    var params = { page: $scope.currentPage - 1, size: $scope.itemsPerPage };
    if ($scope.searchQuery)    params.query    = $scope.searchQuery;
    if ($scope.filterCategory) params.category = $scope.filterCategory;

    $http.get(API, { params: params })
      .then(function(res) {
        var data = res.data;
        if (Array.isArray(data)) {
          $scope.publications = data;
          $scope.totalItems   = data.length;
          $scope.totalPages   = Math.ceil(data.length / $scope.itemsPerPage) || 1;
        } else {
          $scope.publications = data.content || [];
          $scope.totalItems   = data.totalElements || 0;
          $scope.totalPages   = data.totalPages || 1;
        }
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des publications.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  function loadCategories() {
    $http.get(API + '/categories')
      .then(function(res) { $scope.categories = res.data || []; })
      .catch(angular.noop);
  }

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() {
      $scope.currentPage = 1;
      $scope.loadPublications();
    }, 350);
  };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p;
    $scope.loadPublications();
  };

  $scope.getPages = function() {
    var pages = [], start = Math.max(1, $scope.currentPage - 2), end = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  $scope.openModal = function(pub) {
    $scope.editingPub = pub ? angular.copy(pub) : { published: false };
    $scope.showModal  = true;
  };

  $scope.closeModal = function() {
    $scope.showModal  = false;
    $scope.editingPub = {};
  };

  $scope.savePublication = function() {
    if (!$scope.editingPub.title) { flash('errorMsg', 'Le titre est obligatoire.'); return; }
    $scope.saving = true;
    var req = $scope.editingPub.id
      ? $http.put(API + '/' + $scope.editingPub.id, $scope.editingPub)
      : $http.post(API, $scope.editingPub);

    req.then(function() {
      $scope.closeModal();
      $scope.loadPublications();
      flash('successMsg', $scope.editingPub.id ? 'Publication mise à jour.' : 'Publication créée.');
    })
    .catch(function() { flash('errorMsg', 'Erreur lors de l\'enregistrement.'); })
    .finally(function() { $scope.saving = false; });
  };

  $scope.deletePublication = function(pub) {
    if (!confirm('Supprimer "' + pub.title + '" ?')) return;
    $http.delete(API + '/' + pub.id)
      .then(function() { $scope.loadPublications(); flash('successMsg', 'Publication supprimée.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  $scope.loadPublications();
  loadCategories();
}]);
